import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '@htx/environment';
import { Environment } from '../../../environments/model/environment.model';

/**
 * This service loads the configuration in production from the assets/config.json file
 * applied during deployment. This allows changing the configuration for different
 * environments without rebuilding the application. (rancher / stackit)
 */
@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private config: Environment | null = null;
  private http = inject(HttpClient);

  private applyToEnvironment(config: Environment): void {
    environment.backendUrl = config.backendUrl;
    environment.oauth = {
      issuer: config.oauth.issuer,
      clientId: config.oauth.clientId,
      redirectUri: config.oauth.redirectUri,
      requireHttps: config.oauth.requireHttps
    };
  }

  async loadConfig(): Promise<void> {
    if (environment.production) {
      this.config = await firstValueFrom(this.http.get<Environment>('/assets/config.json'));
      this.applyToEnvironment(this.config);
    }
  }

  getConfig(): Environment | null {
    return this.config;
  }
}
